import { Card, CardBody, Col, Input, Label, ListGroup, ListGroupItem } from "reactstrap";
import { ListWithCheckboxTitle } from "../../../constants";
import { ListCheckboxData, ListWithCheckboxSubTitle } from "../../../data/uiKits/Lists";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";

const ListWithCheckbox = () => {
  return (
    <Col xl="4" md="6">
      <Card>
        <CommonCardHeader title={ListWithCheckboxTitle} span={ListWithCheckboxSubTitle} />
        <CardBody className="dark-list">
          <ListGroup>
            {ListCheckboxData &&
              ListCheckboxData.map((item, index) => (
                <ListGroupItem key={index}>
                  <Input className={`me-2 checkbox-${item.class} ${index === 0 ? "active" : ""}`} id={item.idFor} type="checkbox" value="" />
                  <Label className={`mb-0 txt-${item.class}`} htmlFor={item.idFor} check>
                    {item.text}
                  </Label>
                </ListGroupItem>
              ))}
          </ListGroup>
        </CardBody>
      </Card>
    </Col>
  );
};
export default ListWithCheckbox;
